import { NgModule } from '@angular/core';
import { SeUiDatagridComponent } from './se-ui-datagrid.component';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material/material.module';

import { NumericCellEditorComponent } from './components/numeric-cell-editor/numeric-cell-editor.component';
import { NumericCellEditorPopupComponent } from './components/numeric-cell-editor/numeric-cell-editor-popup/numeric-cell-editor-popup.component';
import { CommonModule, DatePipe } from '@angular/common';
import { NumericCellEditorInlineComponent } from './components/numeric-cell-editor/numeric-cell-editor-inline/numeric-cell-editor-inline.component';
import { NumericCellEditorBaseComponent } from './components/numeric-cell-editor/numeric-cell-editor-base/numeric-cell-editor-base.component';

import { LetterCellEditorComponent } from './components/letter-cell-editor/letter-cell-editor.component';
import { LetterCellEditorInlineComponent } from './components/letter-cell-editor/letter-cell-editor-inline/letter-cell-editor-inline.component';
import { LetterCellEditorPopupComponent } from './components/letter-cell-editor/letter-cell-editor-popup/letter-cell-editor-popup.component';
import { LetterCellEditorBaseComponent } from './components/letter-cell-editor/letter-cell-editor-base/letter-cell-editor-base.component';

import { AlphanumericCellEditorComponent } from './components/alphanumeric-cell-editor/alphanumeric-cell-editor.component';
import { AlphanumericCellEditorBaseComponent } from './components/alphanumeric-cell-editor/alphanumeric-cell-editor-base/alphanumeric-cell-editor-base.component';
import { AlphanumericCellEditorInlineComponent } from './components/alphanumeric-cell-editor/alphanumeric-cell-editor-inline/alphanumeric-cell-editor-inline.component';
import { AlphanumericCellEditorPopupComponent } from './components/alphanumeric-cell-editor/alphanumeric-cell-editor-popup/alphanumeric-cell-editor-popup.component';
import { ColumnConstraintTooltipComponent } from './components/column-constraint-tooltip/column-constraint-tooltip.component';

import { DateCellEditorComponent } from './components/date-cell-editor/date-cell-editor.component';
import { DateCellEditorBaseComponent } from './components/date-cell-editor/date-cell-editor-base/date-cell-editor-base.component';
import { DateCellEditorInlineComponent } from './components/date-cell-editor/date-cell-editor-inline/date-cell-editor-inline.component';
import { DateCellEditorPopupComponent } from './components/date-cell-editor/date-cell-editor-popup/date-cell-editor-popup.component';
import { DateCellRendererComponent } from './components/date-cell-renderer/date-cell-renderer.component';

import { BooleanCellRendererComponent } from './components/boolean-cell-renderer/boolean-cell-renderer.component';
import { DetectUserAgent } from './utils/detect-user-agent';

// import { NgxMaskModule } from 'ngx-mask';

import { ComboCellEditorComponent } from './components/combo-cell-editor/combo-cell-editor.component';
import { ComboCellEditorPopupComponent } from './components/combo-cell-editor/combo-cell-editor-popup/combo-cell-editor-popup.component';

import { TranslateModule } from '@ngx-translate/core';
import { EllipsisWithTooltipCellRendererComponent } from './components/ellipsis-with-tooltip-cell-renderer/ellipsis-with-tooltip-cell-renderer.component';
import { TestHostComponent } from './test-utils/test-host.component';

import { MaskedDateCellEditorComponent } from './components/masked-date-cell-editor/masked-date-cell-editor.component';
import { MaskedDateCellEditorBaseComponent } from './components/masked-date-cell-editor/masked-date-cell-editor-base/masked-date-cell-editor-base.component';
import { MaskedDateCellEditorInlineComponent } from './components/masked-date-cell-editor/masked-date-cell-editor-inline/masked-date-cell-editor-inline.component';
import { MaskedDateCellEditorPopupComponent } from './components/masked-date-cell-editor/masked-date-cell-editor-popup/masked-date-cell-editor-popup.component';
import { MaskDirective } from './directives/mask-directive/mask.directive';
import { ButtonCellRendererComponent } from './components/button-cell-renderer/button-cell-renderer.component';
import { AutocompleteCellEditorPopupComponent } from './components/autocomplete-cell-editor/autocomplete-cell-editor-popup/autocomplete-cell-editor-popup.component';
import { AutocompleteCellEditorComponent } from './components/autocomplete-cell-editor/autocomplete-cell-editor.component';

import { SeAutocompleteModule, SePickersModule } from '@se/platform';

import { MultiIconCellRendererComponent } from './components/multi-icon-cell-renderer/multi-icon-cell-renderer.component';

@NgModule({
    declarations: [
        SeUiDatagridComponent,
        NumericCellEditorComponent,
        NumericCellEditorBaseComponent,
        NumericCellEditorPopupComponent,
        NumericCellEditorInlineComponent,
        LetterCellEditorComponent,
        LetterCellEditorInlineComponent,
        LetterCellEditorPopupComponent,
        LetterCellEditorBaseComponent,
        AlphanumericCellEditorComponent,
        AlphanumericCellEditorBaseComponent,
        AlphanumericCellEditorInlineComponent,
        AlphanumericCellEditorPopupComponent,
        ColumnConstraintTooltipComponent,
        DateCellEditorComponent,
        DateCellEditorBaseComponent,
        DateCellEditorInlineComponent,
        DateCellEditorPopupComponent,
        DateCellRendererComponent,
        BooleanCellRendererComponent,
        ComboCellEditorComponent,
        ComboCellEditorPopupComponent,
        EllipsisWithTooltipCellRendererComponent,
        TestHostComponent,
        MaskedDateCellEditorComponent,
        MaskedDateCellEditorBaseComponent,
        MaskedDateCellEditorInlineComponent,
        MaskedDateCellEditorPopupComponent,
        MaskDirective,
        ButtonCellRendererComponent,
        AutocompleteCellEditorComponent,
        AutocompleteCellEditorPopupComponent,
        MultiIconCellRendererComponent

    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        AgGridModule,
        TranslateModule,
        SeAutocompleteModule,
        SePickersModule
    ],
    providers: [
        DatePipe,
        DetectUserAgent
    ],
    exports: [
        NumericCellEditorComponent,
        LetterCellEditorComponent,
        AlphanumericCellEditorComponent,
        SeUiDatagridComponent,
        ColumnConstraintTooltipComponent,
        DateCellEditorComponent,
        DateCellRendererComponent,
        DatePipe,
        BooleanCellRendererComponent,
        ComboCellEditorComponent,
        ButtonCellRendererComponent,
        AutocompleteCellEditorComponent,
        MultiIconCellRendererComponent
    ]
})
export class SeUiDatagridModule {
}
